"use client";
import {
  useSelectContext
} from "../__chunks/FXF6FFAU.js";
import {
  useCompositeSeparator
} from "../__chunks/2INQ6K4L.js";
import "../__chunks/IX2MD5WD.js";
import "../__chunks/53KINMNA.js";
import "../__chunks/FU7RTSEI.js";
import "../__chunks/URSEQETI.js";
import "../__chunks/J7UNXP2A.js";
import "../__chunks/SJ5YBTFK.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/YIF72NQG.js";
import "../__chunks/OPTPHWV7.js";
import "../__chunks/4ROCFRIN.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/select/select-separator.tsx
var TagName = "hr";
var useSelectSeparator = createHook(
  function useSelectSeparator2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useSelectContext();
    store = store || context;
    props = useCompositeSeparator(__spreadValues({ store }, props));
    return props;
  }
);
var SelectSeparator = forwardRef(function SelectSeparator2(props) {
  const htmlProps = useSelectSeparator(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectSeparator,
  useSelectSeparator
};
